var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1548 25.2927C16.3232 24.9136 16.4916 24.4397 16.5758 24.0605C16.9126 22.4493 17.3335 20.8381 17.6703 19.2268C17.7545 18.7529 17.8387 18.3738 17.8387 17.8999C17.7545 17.3312 17.3335 16.8573 16.9126 16.573C16.239 16.1939 15.397 16.2886 14.6392 16.2886C13.9657 16.2886 13.2921 16.2886 12.6185 16.2886C12.1975 16.2886 11.7765 16.2886 11.3555 16.2886C10.9346 16.2886 10.7662 15.9095 10.9346 15.5304C11.3555 14.5826 11.6081 13.8244 11.7765 12.9714C11.8607 12.4975 11.9449 12.1183 11.9449 11.834C11.9449 10.2228 10.5136 10.0332 10.5136 10.0332C10.5136 10.0332 7.22989 14.4878 5.88274 15.72C4.95657 16.573 4.36719 17.6156 4.36719 18.9425V22.165C4.36719 24.8188 4.87237 26.9987 7.65087 26.9987C9.25062 26.9987 10.8504 26.9987 12.4501 26.9987C13.7973 26.9987 15.397 26.8092 16.1548 25.2927ZM16.1548 25.2927C16.1548 25.3875 16.1548 25.3875 16.1548 25.2927Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.5215V26.0516",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8452 2.70536C18.6768 3.08448 18.5084 3.55838 18.4242 3.9375C18.0874 5.54875 17.6665 7.16 17.3297 8.77124C17.2455 9.24514 17.1613 9.62426 17.1613 10.0982C17.2455 10.6668 17.6665 11.1407 18.0874 11.4251C18.761 11.8042 19.603 11.7094 20.3608 11.7094C21.0343 11.7094 21.7079 11.7094 22.3815 11.7094C22.8025 11.7094 23.2235 11.7094 23.6445 11.7094C24.0654 11.7094 24.2338 12.0885 24.0654 12.4676C23.6445 13.4154 23.3919 14.1737 23.2235 15.0267C23.1393 15.5006 23.0551 15.8797 23.0551 16.164C23.0551 17.7753 24.4864 17.9648 24.4864 17.9648C24.4864 17.9648 27.7701 13.5102 29.1173 12.2781C30.0434 11.4251 30.6328 10.3825 30.6328 9.05558V5.83308C30.6328 3.17926 30.1276 0.999336 27.3491 0.999336C25.7494 0.999336 24.1496 0.999336 22.5499 0.999336C21.2027 0.999336 19.603 1.18889 18.8452 2.70536ZM18.8452 2.70536C18.8452 2.61059 18.8452 2.61059 18.8452 2.70536Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10.4766V1.94642",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback_icon.b795d88303f4f9ff50ca020b023a8e88.svg";
export { ForwardRef as ReactComponent };